import type { ComponentProps } from 'react';

import { cn } from '@repo/lib/cn';
import { CheckCircle2, CircleSlashIcon, Loader2Icon, XCircleIcon } from 'lucide-react';

export interface UploadStateIconProps extends ComponentProps<'div'> {
  isPending: boolean;
  isSuccess: boolean;
  isError: boolean;
  isCanceled: boolean;
}

export function UploadStateIcon(uploadStateIconProps: UploadStateIconProps) {
  const { isPending, isSuccess, isError, isCanceled, className, ...props } = uploadStateIconProps;
  return (
    <div className={cn('relative size-4', className)} {...props}>
      <div className={cn('absolute transition-all duration-350', isPending ? 'scale-100 opacity-100' : 'scale-0 opacity-0')}>
        <Loader2Icon aria-hidden="true" className="size-full animate-spin" />
      </div>
      <div className={cn('absolute transition-all duration-350', isSuccess ? 'scale-100 opacity-100' : 'scale-0 opacity-0')}>
        <CheckCircle2 aria-hidden="true" className="stroke-success size-full" />
      </div>
      <div className={cn('absolute transition-all duration-350', isError ? 'scale-100 opacity-100' : 'scale-0 opacity-0')}>
        <XCircleIcon aria-hidden="true" className="stroke-destructive size-full" />
      </div>
      <div className={cn('absolute transition-all duration-350', isCanceled ? 'scale-100 opacity-100' : 'scale-0 opacity-0')}>
        <CircleSlashIcon aria-hidden="true" className="stroke-muted-foreground size-full" />
      </div>
    </div>
  );
}
